import React from "react";
import { useTranslation } from "react-i18next";
import { CardButton } from "extranet-component-library";
import { MENU } from "../utils/constants";
import { getCardConfig, showHeaderCards } from "../utils/parsers";
import { isClaimsVisible } from "../utils/entities/entityMenuVisibility";

const CardsMenu = ({ LinkNavigate, props }: any) => {
  const { t } = useTranslation();
  const showClaims = isClaimsVisible();

  const getConfigCard = (path: string, card: string) => {
    let config = getCardConfig(card);
    if (path === "/" + card) {
      return { ...config, active: true };
    } else return { ...config, active: false };
  };

  return (
    <div className="cards-container">
      {showHeaderCards(props.location.pathname) ? (
        <div
          data-testid="show-cards"
          className="flex-container justify-end cards"
        >
          <CardButton
            id="carnet"
            content={t("carnet").split("/")}
            config={getConfigCard(props.location.pathname, "wallet")}
            LinkNavigate={(pr: any) => LinkNavigate(MENU.WALLET.URL, pr.children, pr.id)}
          />
          <CardButton
            id="next_travel"
            content={t("next_travel").split("/")}
            config={getConfigCard(props.location.pathname, "next-travel")}
            LinkNavigate={(pr: any) => LinkNavigate(MENU.NEXT_TRAVEL.URL, pr.children)}
          />
          <CardButton
            id="my_favs"
            content={t("my_favs").split("/")}
            config={getConfigCard(props.location.pathname, "favorites")}
            LinkNavigate={(pr: any) => LinkNavigate(MENU.FAVORITES.URL, pr.children)}
          />
          {showClaims && (
            <CardButton
              id="claims"
              content={t("claims").split("/")}
              config={getConfigCard(props.location.pathname, "claims")}
              LinkNavigate={(pr: any) => LinkNavigate(MENU.CLAIMS.URL, pr.children)}
            />
          )}
        </div>
      ) : (
        <div data-testid="no-cards"></div>
      )}
    </div>
  );
};

export default CardsMenu;
